import axiosInstance from "../utils/ApiUtils/axiosInstance";

// Fetch the translation details
export const deleteUser = async (userId: number): Promise<void> => {
  const response = await axiosInstance.delete(`/api/user/delete/${userId}`);
  return response.data.data;
};
